import React from 'react';
import Header from '../../components/header';
import Footer from '../../components/footer';
import { CssBaseline, Grid2 } from '@mui/material';
import Breadcrumbs from '../../components/Breadcrumb';
import { useAuth } from '../../contexts/AuthContext';
import { useEffort } from '../../contexts/EffortContext';

interface LayoutProps {
  children?: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { activePage, setActivePage } = useAuth();
  const { effortName } = useEffort();

  return (
    <>
      <CssBaseline />
      <Grid2
        container
        direction='column'
        justifyContent='space-between'
        sx={{ height: '100%', minHeight: '100vh' }}
      >
        <Grid2 sx={{ maxWidth: '100%' }}>
          <Header />
        </Grid2>
        <Grid2 sx={{ flex: 1, paddingTop: '64px', maxWidth: '100%' }}>
          <Breadcrumbs
            sx={{
              position: 'relative',
            }}
            activePage={activePage}
            setActivePage={setActivePage}
            selectedEffortName={effortName}
          />
          {children}
        </Grid2>
        <Grid2 sx={{ maxWidth: '100%', flexShrink: 0 }}>
          <Footer />
        </Grid2>
      </Grid2>
    </>
  );
};

export default Layout;
